// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReceiptInfoPanel_panel__6-mVJ {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.98);
  border-top: 1px solid #e5e7eb;
  font-size: 0.9rem;
  z-index: 100;
  backdrop-filter: blur(8px);
  padding: 8px 12px 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.07);
}

/* === Header === */
.ReceiptInfoPanel_header__3t7wb {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 2px;
}

.ReceiptInfoPanel_left__J3OSR {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
}

.ReceiptInfoPanel_right__fhH9l {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.ReceiptInfoPanel_num__MTAni {
  font-weight: 600;
  color: #111;
}

.ReceiptInfoPanel_contract__fREiU {
  color: #666;
}

.ReceiptInfoPanel_client__7D4Se {
  color: #222;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ReceiptInfoPanel_status__tSg16 {
  font-weight: 600;
}

.ReceiptInfoPanel_time__oImBd {
  color: #666;
  font-size: 0.82rem;
}

.ReceiptInfoPanel_icon__MWRjV {
  color: #888;
}

.ReceiptInfoPanel_iconSmall__W4O9X {
  color: #999;
  flex-shrink: 0;
}

/* === Middle === */
.ReceiptInfoPanel_middle__GVfo1 {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  color: #444;
}

.ReceiptInfoPanel_addr__HLKpm {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ReceiptInfoPanel_reason__wfJzx {
  color: #b91c1c;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 4px;
}

/* === Progress Row === */
.ReceiptInfoPanel_progressRow__Yq1vy {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.ReceiptInfoPanel_progressBar__-rBjK {
  position: relative;
  flex: 0 0 150px; /* компактная ширина, не во всю линию */
  height: 8px;
  border-radius: 4px;
  background: #e5e7eb;
  overflow: hidden;
}

.ReceiptInfoPanel_progressFill__UFYp4 {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.ReceiptInfoPanel_ok__S3FKb,
.ReceiptInfoPanel_warn__y0h5I {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.82rem;
  font-weight: 500;
}

.ReceiptInfoPanel_ok__S3FKb {
  color: #16a34a;
}

.ReceiptInfoPanel_warn__y0h5I {
  color: #f59e0b;
}

/* === Products === */
.ReceiptInfoPanel_products__-ifGz {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 2px;
}

.ReceiptInfoPanel_product__EaVvB {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.82rem;
  padding: 2px 6px;
  border-radius: 6px;
  background: #f3f4f6;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.2s;
}

.ReceiptInfoPanel_prodName__Oxn-0 {
  max-width: 180px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.ReceiptInfoPanel_prodCount__Nme1E {
  font-weight: 500;
}

.ReceiptInfoPanel_prodDone__WmStn {
  background: #dcfce7;
  color: #166534;
}

.ReceiptInfoPanel_prodPartial__LUgys {
  background: #e0f2fe;
  color: #1d4ed8;
}

.ReceiptInfoPanel_prodNone__OlnJZ {
  background: #fef2f2;
  color: #b91c1c;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Logist/Routes/modal/map/ReceiptInfoPanel.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,qCAAqC;EACrC,6BAA6B;EAC7B,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,0CAA0C;AAC5C;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe,EAAE,uCAAuC;EACxD,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".panel {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  background: rgba(255, 255, 255, 0.98);\r\n  border-top: 1px solid #e5e7eb;\r\n  font-size: 0.9rem;\r\n  z-index: 100;\r\n  backdrop-filter: blur(8px);\r\n  padding: 8px 12px 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.07);\r\n}\r\n\r\n/* === Header === */\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  row-gap: 2px;\r\n}\r\n\r\n.left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex: 1;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.num {\r\n  font-weight: 600;\r\n  color: #111;\r\n}\r\n\r\n.contract {\r\n  color: #666;\r\n}\r\n\r\n.client {\r\n  color: #222;\r\n  font-weight: 500;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.status {\r\n  font-weight: 600;\r\n}\r\n\r\n.time {\r\n  color: #666;\r\n  font-size: 0.82rem;\r\n}\r\n\r\n.icon {\r\n  color: #888;\r\n}\r\n\r\n.iconSmall {\r\n  color: #999;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* === Middle === */\r\n.middle {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  color: #444;\r\n}\r\n\r\n.addr {\r\n  flex: 1;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.reason {\r\n  color: #b91c1c;\r\n  font-size: 0.85rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n/* === Progress Row === */\r\n.progressRow {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.progressBar {\r\n  position: relative;\r\n  flex: 0 0 150px; /* компактная ширина, не во всю линию */\r\n  height: 8px;\r\n  border-radius: 4px;\r\n  background: #e5e7eb;\r\n  overflow: hidden;\r\n}\r\n\r\n.progressFill {\r\n  height: 100%;\r\n  border-radius: 4px;\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.ok,\r\n.warn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  font-size: 0.82rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.ok {\r\n  color: #16a34a;\r\n}\r\n\r\n.warn {\r\n  color: #f59e0b;\r\n}\r\n\r\n/* === Products === */\r\n.products {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n  margin-top: 2px;\r\n}\r\n\r\n.product {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  font-size: 0.82rem;\r\n  padding: 2px 6px;\r\n  border-radius: 6px;\r\n  background: #f3f4f6;\r\n  user-select: none;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.prodName {\r\n  max-width: 180px;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n}\r\n\r\n.prodCount {\r\n  font-weight: 500;\r\n}\r\n\r\n.prodDone {\r\n  background: #dcfce7;\r\n  color: #166534;\r\n}\r\n\r\n.prodPartial {\r\n  background: #e0f2fe;\r\n  color: #1d4ed8;\r\n}\r\n\r\n.prodNone {\r\n  background: #fef2f2;\r\n  color: #b91c1c;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `ReceiptInfoPanel_panel__6-mVJ`,
	"header": `ReceiptInfoPanel_header__3t7wb`,
	"left": `ReceiptInfoPanel_left__J3OSR`,
	"right": `ReceiptInfoPanel_right__fhH9l`,
	"num": `ReceiptInfoPanel_num__MTAni`,
	"contract": `ReceiptInfoPanel_contract__fREiU`,
	"client": `ReceiptInfoPanel_client__7D4Se`,
	"status": `ReceiptInfoPanel_status__tSg16`,
	"time": `ReceiptInfoPanel_time__oImBd`,
	"icon": `ReceiptInfoPanel_icon__MWRjV`,
	"iconSmall": `ReceiptInfoPanel_iconSmall__W4O9X`,
	"middle": `ReceiptInfoPanel_middle__GVfo1`,
	"addr": `ReceiptInfoPanel_addr__HLKpm`,
	"reason": `ReceiptInfoPanel_reason__wfJzx`,
	"progressRow": `ReceiptInfoPanel_progressRow__Yq1vy`,
	"progressBar": `ReceiptInfoPanel_progressBar__-rBjK`,
	"progressFill": `ReceiptInfoPanel_progressFill__UFYp4`,
	"ok": `ReceiptInfoPanel_ok__S3FKb`,
	"warn": `ReceiptInfoPanel_warn__y0h5I`,
	"products": `ReceiptInfoPanel_products__-ifGz`,
	"product": `ReceiptInfoPanel_product__EaVvB`,
	"prodName": `ReceiptInfoPanel_prodName__Oxn-0`,
	"prodCount": `ReceiptInfoPanel_prodCount__Nme1E`,
	"prodDone": `ReceiptInfoPanel_prodDone__WmStn`,
	"prodPartial": `ReceiptInfoPanel_prodPartial__LUgys`,
	"prodNone": `ReceiptInfoPanel_prodNone__OlnJZ`
};
export default ___CSS_LOADER_EXPORT___;
